// Author Liang Gang Qiang
// Date 2021-11-03 15:05:19

import * as model from "@/model/mintalMes/quality/MintalMesQualityProductionProjectModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";
import {customVuexFilterPatternFactory} from "@/store/em/commonPattern/customVuexFilterPatternFactory";
import {customVuexVoPatternFactory} from "@/store/em/commonPattern/customVuexVoPatternFactory";
import {customVuexEntityPatternFactory} from "@/store/em/commonPattern/customVuexEntityPatternFactory";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.MintalMesQualityProductionProject(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_MINTALMES_QUALITY_URL,
    })
    .withPatternFactory(customVuexFilterPatternFactory, {
        filterState: 'mintalMesQualityProductionProjectProductionFilter',
        filterInitializer: newFilter
    })
    .withPatternFactory(customVuexFilterPatternFactory, {
        filterState: 'mintalMesQualityProductionProjectInventoryFilter',
        filterInitializer: newFilter
    })
    .withPatternFactory(customVuexEntityPatternFactory, {
        entityState: 'mintalMesQualityProductionProjectProductionEntity',
        entityConstructor: model.MintalMesQualityProductionProject
    })
    .withPatternFactory(customVuexEntityPatternFactory, {
        entityState: 'mintalMesQualityProductionProjectInventoryEntity',
        entityConstructor: model.MintalMesQualityProductionProject
    })
    .withPatternFactory(customVuexVoPatternFactory, {
        voState: 'mintalMesQualityProductionProjectProductionVo'
    })
    .withPatternFactory(customVuexVoPatternFactory, {
        voState: 'mintalMesQualityProductionProjectInventoryVo'
    })
    .withPatternFactory(customVuexVoPatternFactory, {
        voState: 'productionVo'
    })
    .buildStore()
